import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  addTicker,
  confirmationRequest,
  fetchTickerSeries,
  setPageTitle,
  updateTicker,
  updateTickerPositions,
  updateTickerSeries,
  addUserReport,
} from '../../actions';
import { TICKERS_RESOURCE } from '../../api/resources';
import { EditableLabel, Page, TickerAddView, TickerSeriesView } from '../../components';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';
import { getTickerSeries, getProfile } from '../../selectors';

class TickerSeriesPage extends React.Component {
  static propTypes = {
    fetchTickerSeries: PropTypes.func.isRequired,
    updateTickerSeries: PropTypes.func.isRequired,
    updateTickerPositions: PropTypes.func.isRequired,
    updateTicker: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    addTicker: PropTypes.func.isRequired,
    confirmationRequest: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    tickerSeries: PropTypes.object,
    addUserReport: PropTypes.func.isRequired,

  };

  constructor(props) {
    super(props);
    this.state = {
      adding: false,
      reportActivityStatus: this.props.profile && this.props.profile.features && this.props.profile.features.record_user_activity

    
    };
  }

  componentDidMount() {
    this.props.fetchTickerSeries();
    this.props.setPageTitle('Ticker Series');
  }

  handleAddTicker = () =>
    this.setState({adding: true})

  handleCancelAdd = () =>
    this.setState({adding: false})

  handleRename = (newName) =>
    this.props.updateTickerSeries(this.props.tickerSeries.id, {name: newName})

  handleReorder = (tickers) =>
    this.props.updateTickerPositions(tickers)

  handleTickerAdd = (ticker) => {
    var substr=ticker.text.substr(0, 21);
    const {profile} = this.props;

    this.props.addTicker({...ticker, ticker_series: this.props.tickerSeries.id});
    this.setState({adding: false});
    if (this.state.reportActivityStatus){ 
      this.props.addUserReport({
        user: profile.id,
        action_type: "Update",
        activity:`added a new ticker text  "${substr}" in ${this.props.tickerSeries.name}"`
      });
  }
  }

  handleTickerChange = (ticker) =>
    this.props.updateTicker(ticker.id, ticker)

  handleTickerDelete = (tickerId) => {
    this.props.confirmationRequest(
      'Deleting Ticker',
      'This is a permanent action',
      'DELETE',
      TICKERS_RESOURCE,
      tickerId);

      if (this.state.reportActivityStatus){ 
        this.props.addUserReport({
          user: profile.id,
          action_type: "Delete",
          activity:`deleted (or attempt to delete) ticker with id  ${tickerId}`
      });
    }
  }

  render() {
    const {tickerSeries} = this.props;

    if (tickerSeries === undefined) {
      return <div>Invalid ticker series.</div>;
    }

    return (
      <Page>
        <h2>
          <EditableLabel value={tickerSeries.name} onChange={this.handleRename}/>
        </h2>
        <TickerSeriesView tickers={tickerSeries.tickers}
                          onTickerDelete={this.handleTickerDelete}
                          onTickerAdd={this.handleTickerAdd}
                          onReorder={this.handleReorder}
                          onTickerChange={this.handleTickerChange}/>
        <Box direction="row">
          <Button onClick={!this.state.adding ? this.handleAddTicker : null}>Add Ticker</Button>
        </Box>
        {this.state.adding ?
         <TickerAddView onSave={this.handleTickerAdd} onCancel={this.handleCancelAdd}/> : null}
      </Page>
    );
  }
}

export default connect((state, {match}) => ({
  tickerSeries: getTickerSeries(state, parseInt(match.params.id, 10)),
  profile: getProfile(state),
}), {
  fetchTickerSeries,
  updateTickerSeries,
  confirmationRequest,
  updateTickerPositions,
  updateTicker,
  addTicker,
  setPageTitle,
  addUserReport,
})(TickerSeriesPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/TickerSeriesPage/index.js